import * as React from 'react';
import { observer } from 'mobx-react';
import { Amount } from 'nomst/Stores/Decision/amount';
import { CycleBudgetField } from 'nomst/Stores/Configuration/cycleBudgetField';
import { StockAmount } from 'nomst/Stores/Decision/stockAmount';
import { Option } from '@payscale/design';

interface IEligibilityProrationOption {
    employeeAmount: Amount | StockAmount;
    cycleBudgetField: CycleBudgetField;
}

export class EligibilityProrationOption extends React.Component<IEligibilityProrationOption> {
    constructor(props: IEligibilityProrationOption) {
        super(props);
        this.handleOverrideEligibility = this.handleOverrideEligibility.bind(this);
        this.handleOverrideProration = this.handleOverrideProration.bind(this);
    }
    render(): JSX.Element {
        const { cycleBudgetField, employeeAmount } = this.props;
        return (
            <tr>
                <th className="proration-table-header">
                    {cycleBudgetField.title}
                </th>
                <td>
                    <div
                        className="pxl-form-group"
                    >
                        <Option
                            checked={employeeAmount.isEligible}
                            onChange={this.handleOverrideEligibility}
                            text="Eligible"
                            className="pxl-option--secondary"
                        />
                    </div>
                </td>
                <td>
                    {this.renderProrationFormGroup()}
                </td>
            </tr>
        );
    }

    private renderProrationFormGroup(): JSX.Element {
        const { cycleBudgetField, employeeAmount } = this.props;
        if (!cycleBudgetField.prorationRule) {
            return (
                <span className="pxl-text-c11-2 no-proration-setup">
                    No proration rules set up
                </span>
            );
        }

        return (
            <div
                className="pxl-form-group"
            >
                <Option
                    checked={employeeAmount.isProrationOverride}
                    onChange={this.handleOverrideProration}
                    text="Override Proration rules"
                    className="pxl-option--secondary proration-option"
                />
            </div>
        );
    }

    private handleOverrideEligibility(_: undefined, value: IOnChangeEvent): void {
        const { employeeAmount } = this.props;
        employeeAmount.overrideEligibility(value.target.checked);
    }

    private handleOverrideProration(_: undefined, value: IOnChangeEvent): void {
        const { employeeAmount } = this.props;
        employeeAmount.overrideProration(value.target.checked);
    }
}

export default observer(EligibilityProrationOption);